import { type Action, CARD_FOCUS, CARD_BLUR } from '../../../../actions/cards/focus/index.tsx';
import type { FocusedState } from './types.tsx';

const initialState: FocusedState = null;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Action };

export const focusedReducer = (state: FocusedState = initialState, action: Action) => {
	if (action.type === CARD_FOCUS) {
		return action.payload.cardId;
	}

	if (action.type === CARD_BLUR) {
		return null;
	}

	return state;
};
